import { MediaIntegrationId } from 'components/VideoTemplateEditor/types';
import { VideoTemplateStateContent } from '../../types';

export function hasAutoframedDynamicVideo(state: VideoTemplateStateContent) {
  const { videoClips } = state;

  if (!videoClips?.order) {
    return false;
  }

  return videoClips.order.some(videoId => {
    const videoClip = videoClips.data[videoId];

    if (!videoClip) {
      return false;
    }

    const isDynamic =
      videoClip.integrationData?.id === MediaIntegrationId.DYNAMIC;

    if (!isDynamic) {
      return false;
    }

    return videoClip.framingMethod === 'autoframe';
  });
}
